(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("stylefire"), require("popmotion"));
	else if(typeof define === 'function' && define.amd)
		define(["stylefire", "popmotion"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("stylefire"), require("popmotion")) : factory(root["stylefire"], root["popmotion"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 